import React from "react"
import {withRouter} from "react-router-dom"
import {ClubComplaintManagerProvider} from "./store/useClubComplaintManagerContext"
import ClubComplaintList from "./component/ClubComplaintList"

/**
 * 投诉管理
 */
const ClubComplaintManager = () => {
    return (
        <div className={'club-complaint-manager'}>
            <ClubComplaintManagerProvider>
                <ClubComplaintList></ClubComplaintList>
            </ClubComplaintManagerProvider>
        </div>
    )
}

export default withRouter(ClubComplaintManager)


// WEBPACK FOOTER //
// ./src/containers/ClubComplaintManager/index.js